import moment from "moment";
export const formatDateWithMoment = (date: string | Date, format: string = "MMM DD, YYYY"): string => {
    return moment(date).format(format);
  };